// Lëtzebuergescht Fragment vum Kaaftunnel: Wuerekuerf (Cart.jsx) a
// Checkout (Checkout.jsx). Iwwersetzung vun fr/tunnel.js — déiselwecht
// Schlësselen, déiselwecht Reiefolleg.
// Toun: „du“ am Wuerekuerf, „Dir“ vum Checkout un (wéi am Franséischen).
export default {
  // --- Wuerekuerf (Cart.jsx) ---
  'tunnel.panier.seoTitre': 'Mäi Wuerekuerf',
  'tunnel.panier.seoDescription':
    'Kuckt Äre Joyful-Reveal-Wuerekuerf a bezuelt sécher mat Stripe. Hutt Dir e Promo-Code? Gitt en hei nach eng Kéier an.',
  'tunnel.panier.titre': '🛒 Däi Wuerekuerf',
  'tunnel.panier.sousTitreVide':
    'Fänk d’Aventure un a sammel d’Puzzlestécker',
  'tunnel.panier.sousTitreUn': 'Du hues {n} Stéck an dengem Wuerekuerf',
  'tunnel.panier.sousTitrePlusieurs': 'Du hues {n} Stécker an dengem Wuerekuerf',
  'tunnel.panier.retireTitreUn': 'En Artikel gouf aus Ärem Wuerekuerf ewechgeholl',
  'tunnel.panier.retireTitrePlusieurs':
    'Artikele goufen aus Ärem Wuerekuerf ewechgeholl',
  'tunnel.panier.retireDetail':
    '{noms} — dëse Pack gëtt net méi ugebueden. Eis aktuell Packe fannt Dir am',
  'tunnel.panier.retireDetailLien': 'Shop',
  'tunnel.panier.progression': 'Sammlung am Gaang',
  'tunnel.panier.videTitre': 'Eidele Wuerekuerf',
  'tunnel.panier.videTexte':
    'Hei ass nach näischt ze gesinn... nach net! Fänk deng Aventure un a sammel d’Puzzlestécker.',
  'tunnel.panier.videCta': '🎯 Zréck an d’Aventure',
  'tunnel.panier.langue': 'Sprooch:',
  'tunnel.panier.retirerDuPanier': 'Aus dem Wuerekuerf ewechhuelen',
  'tunnel.panier.sousTotal': 'Zwëschesumm',
  'tunnel.panier.reduction': 'Remise ({code})',
  'tunnel.panier.retirer': 'Ewechhuelen',
  'tunnel.panier.livraison': 'Liwwerung',
  'tunnel.panier.livraisonADeterminer': 'Nach ze bestëmmen',
  'tunnel.panier.codePromo': 'Promo-Code',
  'tunnel.panier.appliquer': 'Uwenden',
  'tunnel.panier.promoAppliquee': 'Code "{code}" applizéiert!',
  'tunnel.panier.total': 'Total',
  'tunnel.panier.offreSpeciale':
    'Speziell Sammlung fräigeschalt! Du bass no beim grousse Geheimnis.',
  'tunnel.panier.continuerCollecter': '← Weider sammelen',
  'tunnel.panier.procederPaiement': '🎯 Weider zum Bezuelen',

  // --- Checkout (Checkout.jsx) ---
  'tunnel.checkout.seoTitre': 'Bezuelen - Sécher ofrechnen',
  'tunnel.checkout.seoDescription':
    'Schléisst Äre Kaf vum Joyful-Reveal-Puzzle sécher mat Stripe of. Séier Liwwerung a Frankräich an an Europa.',
  'tunnel.checkout.chargement': 'Gëtt gelueden...',
  'tunnel.checkout.erreur': '❌ Feeler: {message}',
  'tunnel.checkout.etape': 'Etapp {n} / 3',
  'tunnel.checkout.sansCompte':
    '✅ Dir musst kee Kont uleeën — Är E-Mail-Adress geet duer, fir d’Bestätegung an d’Verfollegung vum Pak ze kréien.',
  'tunnel.checkout.dejaCompte': 'Hutt Dir schonn e Kont?',
  'tunnel.checkout.dejaCompteLien': 'Loggt Iech an',
  'tunnel.checkout.dejaCompteFin': 'fir Är Bestellungen erëmzefannen.',
  'tunnel.checkout.etape1Titre': '📍 Liwweradress',
  'tunnel.checkout.champNomComplet': 'Kompletten Numm',
  'tunnel.checkout.champEmail': 'E-Mail',
  'tunnel.checkout.champAdresse': 'Adress',
  'tunnel.checkout.champVille': 'Uertschaft',
  'tunnel.checkout.champCodePostal': 'Postleitzuel',
  'tunnel.checkout.choisirPays': 'E Land wielen',
  'tunnel.checkout.paysFR': 'Frankräich',
  'tunnel.checkout.paysBE': 'Belsch',
  'tunnel.checkout.paysLU': 'Lëtzebuerg',
  'tunnel.checkout.paysDE': 'Däitschland',
  'tunnel.checkout.paysES': 'Spuenien',
  'tunnel.checkout.paysIT': 'Italien',
  'tunnel.checkout.paysNL': 'Nidderlanden',
  'tunnel.checkout.paysPT': 'Portugal',
  'tunnel.checkout.etape2Titre': '🚚 Liwwerart',
  'tunnel.checkout.calculTarifs': 'Tariffer gi berechent...',
  'tunnel.checkout.etapeSuivanteRequise': 'Nächst Etapp néideg',
  'tunnel.checkout.choisirPointRelaisTexte':
    'Wielt den Ofhuelpunkt, wou Dir Är Bestellung ofhuele wëllt',
  'tunnel.checkout.choisirPointRelaisBouton':
    '🗺️ KLICKT HEI, FIR ÄREN OFHUELPUNKT ZE WIELEN',
  'tunnel.checkout.pointRelaisSelectionne': '✓ Ofhuelpunkt gewielt',
  'tunnel.checkout.modifier': 'Änneren',
  // De Wieler vun den Ofhuelpunkten ass en externt Skript: en ka feelen (Netz,
  // Reklamblocker). Dës Messagen ersetzen englesch alert()-Fënsteren.
  'tunnel.checkout.selecteurIndisponible':
    'D’Kaart mat den Ofhuelpunkte konnt net gelueden ginn. Luet d’Säit nei, a wann et weider net geet, schalt Äre Reklamblocker fir d’Zäit vun der Bestellung of.',
  'tunnel.checkout.choisirTransporteurDabord':
    'Wielt fir d’éischt eng Liwwerart hei uewen.',
  'tunnel.checkout.selecteurErreur':
    'D’Kaart mat den Ofhuelpunkten huet net geäntwert. Probéiert et an engem Moment nach eng Kéier.',
  // Liwwerart bei all Optioun: Sendcloud schéckt der eng zéng zréck, an den
  // Numm vum Produit seet net, wou de Pak ukënnt.
  'tunnel.checkout.modePointRelais': '📍 Ofhuelpunkt',
  'tunnel.checkout.modeDomicile': '🏠 Heem geliwwert',
  // Weist sech nëmmen, wa mir wierklech eppes iwwerhuelen (kuck fr/tunnel.js).
  'tunnel.checkout.participation': '💚 Mir iwwerhuele {montant} € vun dësem Trajet',
  // Richteg, well den Tarif vum Transporteur kënnt, op de Cent genee: mir
  // rechnen keng Marge dobäi. Gëllt fir all Land, ouni een erauszepicken.
  'tunnel.checkout.portSansMarge':
    'Den ugewisenen Tarif ass deen vum Transporteur, op de Cent genee — mir rechnen näischt dobäi.',
  'tunnel.checkout.livraisonDomicileTexte':
    '✓ Direkt op Är Adress geliwwert: {adresse}',
  'tunnel.checkout.indispoTitre':
    '⏳ Liwwerung an dëst Land ass am Moment net méiglech',
  'tunnel.checkout.indispoTexte':
    'De Moment bitt eis kee Transporteur dëse Trajet un. Mir schaffe drun, fir en opzemaachen — kontrolléiert an der Tëschenzäit déi aginn Adress (Postleitzuel an Uertschaft), wielt en anert Liwwerland, oder schreift eis: mir fannen zesummen eng Léisung.',
  'tunnel.checkout.indispoModifierAdresse': '← Adress änneren',
  'tunnel.checkout.indispoContact': '💬 Kontaktéiert eis',
  'tunnel.checkout.voirPlusOptions': '↓ Déi {n} aner Transporteuren weisen',
  'tunnel.checkout.voirMoinsOptions': '↑ Manner Optioune weisen',
  'progression.complete': '✨ ENTHÜLLUNG KOMPLETT! ✨',
  'progression.restant': 'Nach {n} Stécker z’entdecken',
  // Le tunnel de commande compte des ÉTAPES : y afficher « Plus que 23
  // pièces à découvrir » juste au-dessus du bouton de paiement inquiétait
  // l'acheteur au lieu de le rassurer.
  'progression.etapeRestante': "Nach {n} Schrëtt virun der Bezuelung",
  'progression.etapesRestantes': "Nach {n} Schrëtt virun der Bezuelung",
  'progression.pretAPayer': "Leschte Schrëtt: d’Bezuelung",
  'tunnel.panier.etape': "Äre Kuerf",
  'tunnel.checkout.tarifsAttenteLongue':
    'Ee Moment, d’Verbindung mam Transporteur dauert e bësse méi laang wéi soss.',
  'tunnel.checkout.tarifsReprise':
    'Den Transporteur äntwert net, mir probéieren et nach eng Kéier ({n}/{total})…',
  'tunnel.checkout.tarifsErreurTitre':
    "⚠️ D'Portkäschte konnte net berechent ginn",
  'tunnel.checkout.tarifsErreurTexte':
    'Mir hunn et dräi Mol vergeeblech probéiert. Dat läit net un Ärem Land, mee un eiser Verbindung mam Transporteur. Start d’Berechnung nei — wann et bleift, schreift eis, a mir maachen d’Bestellung zesumme mat Iech fäerdeg.',
  'tunnel.checkout.tarifsReessayer': '↻ Nach eng Kéier probéieren',
  'tunnel.checkout.etape3Titre': '💳 Bezuelen',
  'tunnel.checkout.redirectionStripe':
    'Dir gitt op eng sécher Bezuelsäit vu Stripe weidergeleet.',
  'tunnel.checkout.redirection': 'Weiderleedung...',
  'tunnel.checkout.procederPaiement': 'Sécher bezuelen →',
  'tunnel.checkout.retour': '← Zréck',
  'tunnel.checkout.continuer': 'Weider →',
  'tunnel.checkout.recapitulatif': '📦 Iwwerbléck',
  'tunnel.checkout.recapLivraison': '🚚 Liwwerung ({nom})',
  'tunnel.checkout.recapReduction': '🏷️ Remise ({code})',
  'tunnel.checkout.total': 'Total:',
  'tunnel.checkout.paiementReussi': 'Bezuelung gelongen!',
};
